// @ts-check
import { CacheHolder } from './CacheHolder';

/**
 * @template T
 */
export class SimpleCacheHandler {
  /**
   * @param {number} size 
   * @param {string[]} primary
   */
  constructor(size = undefined, primary = ['id']) {
    /** @type {CacheHolder<T>} */
    this.byId = new CacheHolder(size);
    this.primary = primary;
  }

  /**
   * @param {string|number} key 
   * @return {T}
   */
  get(key) {
    return this.byId.get(key);
  }

  getAll() {
    return this.byId.keys().map(key => this.byId.get(key));
  }

  getKeys() {
    return this.byId.keys();
  }

  /**
 * @param {string|number} key 
 * @return {boolean}
 */
  has(key) {
    return this.byId.has(key);
  }

  /**
   * @param {T} data 
   * @return {String}
   */
  getId(data) {
    return this.primary.map(p => data[p]).join('+');
  }

  /**
   * @param {T[]} datas 
   */
  setDatas(datas) {
    datas.forEach(data => {
      this.byId.set(this.getId(data), data);
    });
  }

  /**
   * @param {string|number} id 
   * @param {Partial<T>} diff 
   */
  update(id, diff) {
    const data = this.byId.get(id);
    if (data) {
      this.byId.set(id, { ...data, ...diff });
    }
  }

  /**
   * @param {T} data
   */
  replace(id, data) {
    this.byId.set(id, data);
  }

  /**
   * @param {T} data 
   */
  create(id, data) {
    this.byId.set(id, data);
  }

  /**
   * @param {string|number} id 
   */
  delete(id) {
    this.byId.delete(id);
  }

  clear() {
    this.byId.clear();
  }
}